// extracted by mini-css-extract-plugin
module.exports = {"Statistics":"style_Statistics__2W9hi","emoji":"style_emoji__3-z_X","value":"style_value__16lvD"};